<template>
  <button
    class="sort-button"
    :class="{'active': isActive}" 
    @click="toggleSort"
  >
      <i class="fas fa-sort-alpha-down" v-if="direction === 'asc'"></i><i class="fas fa-sort-alpha-up" v-if="direction === 'desc'"></i> 
      <span class="button-text">{{buttonLabel}}</span>
  </button>
</template>

<script>
export default {
  name: 'SortToggle',
  props: {
    direction: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    activeField: {
      type: String,
      required: true
    },
    buttonLabel: {
      type: String,
      required: true
    }
  },
  computed: {
    isActive() {
      return this.field === this.activeField
    },
  },
  methods: {
    toggleSort() {
      const direction = (this.direction === 'asc') ? 'desc' : 'asc';

      this.$emit('sorted', { direction, field: this.field })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_config.scss';

.button-text {
  font-size: 14px;
  padding-left: 10px;
}

.sort-button {
  font-size: 16px;
  padding: 5px 10px;
  border-radius: 3px;
  border: 1px solid $accent-color;
  transition: background-color .3s, color .3s;

  i,
  span {
    font-weight: bold;
    color: $accent-color;
  }

  &:hover {
    background-color: $accent-color;
    color: #fff;

    i,
    span {
      color: #fff;
    }
  }

  &.active {
    border-color: $dark-blue;
    background-color: $dark-blue;
    color: #fff;

    i,
    span {
      color: #fff;
    }
  }
}
</style>


